import { addError, addWarning } from 'actions/Error';
import { applyPromotion, removePromotion } from 'actions/ShoppingCart';
import { seniorTagID } from 'plugins/mm/constants';
import { getConfiguration } from 'plugins/mm/configuration';
import { PosPlugin } from 'plugins/plugin';
import { addTag, removeTag } from 'services/CustomerRegistery/index';
import { getManualPromotions } from 'reducers/CampaignsDB';

export const addSeniorTagToCustomer: Required<
  PosPlugin
>['onSaveCustomer']['after'] = (p, customerId) => async (
  dispatch,
  getState,
) => {
  const hasSeniorTag = p.tags?.find(tag => tag.id === seniorTagID);

  if (!!p.senior && !hasSeniorTag) {
    try {
      await addTag({ customerId, tagId: seniorTagID });
    } catch (error) {
      dispatch(addError('Failed to assign senior status to customer'));
    }
  } else if (!p.senior && hasSeniorTag) {
    try {
      await removeTag({ customerId, tagId: seniorTagID });
    } catch (error) {
      dispatch(addError('Failed to remove senior status from customer'));
    }
  }
};

export const applySeniorPromotion: Required<
  PosPlugin
>['onSetCustomer']['after'] = (p, o) => async (dispatch, getState) => {
  const hasSeniorTag = o.tags?.find(tag => tag.id === seniorTagID);
  const promotions = getManualPromotions(getState());
  const config = getConfiguration(getState());
  const promotion = promotions.find(
    promotion => promotion.campaignID === config.seniorPromotionID,
  );
  if (!promotion) {
    dispatch(addWarning('No senior promotion configured'));
    return;
  }
  !hasSeniorTag
    ? dispatch(removePromotion(promotion.campaignID))
    : dispatch(applyPromotion({ ...promotion, amount: 1 }));
};
